import axios, { AxiosResponse } from 'axios';
import { loadConfig } from '@api/api';
import { StudyRes } from '@models/Study';
import { access } from 'node:fs';
import { isEmpty } from 'lodash';
import { toSnakeCase } from 'utils/caseConverter';

const getStudyApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/study`;
};

function stringToSnakeCase(str: string) {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export const getAllstudy = async ({
  accessToken,
  params = { page: 1, limit: 10, filters: {}, sort: [] },
}: {
  accessToken: string;
  params: {
    page: number;
    limit: number;
    filters: Record<string, any>;
    sort: Record<string, any>;
  };
}) => {
  const Study_API = await getStudyApi();

  const { sortBy, sortDirection } = params.sort || {};
  const {
    startDate,
    endDate,
    statuses,
    patient_birthdate,
    study_description,
    patientId,
    patient_name,
  } = params.filters;

  const queryParams: Record<string, any> = {
    page: params.page,
    limit: params.limit,
  };


  const filters: Record<string, any> = {};
  if (study_description && study_description.trim() !== '') {
    filters.study_description = study_description.trim();
  }
  if (patientId && patientId.trim() !== '') {
    filters.patient = {
      ...(filters.patient ?? {}),
      patientId: patientId.trim(),
    };
  }
   if (patient_name && patient_name.trim() !== '') {
     filters.patient = {
       ...(filters.patient ?? {}),
       patient_name: patient_name.trim(),
     };
   }

  if (startDate) filters.start_date = startDate;
  if (endDate) filters.end_date = endDate;
  if (statuses)
    filters.statuses = statuses.split(',').map((s: string) => s.trim());
  if (patient_birthdate){
      filters.patient = {
      ...(filters.patient ?? {}),
      patient_birthdate,
    };
  }

  if (Object.keys(filters).length > 0) {
    queryParams.filters = JSON.stringify(filters);
  }

  const isPatient = !!sortBy && sortBy.includes('patient');

  if (sortBy && sortDirection) {
    const orderByValue = isPatient
      ? 'patient.patientId'
      : stringToSnakeCase(sortBy);
    queryParams.sort = JSON.stringify([
      { orderBy: orderByValue, order: sortDirection },
    ]);
  }
  const res: AxiosResponse<StudyRes> = await axios({
    method: 'get',
    url: `${Study_API}`,
    params: queryParams,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return res;
};

export const deleteStudyById = async ({
  id,
  accessToken,
}: {
  id: string;
  accessToken: string;
}) => {
  const STUDY_API = await getStudyApi();

  const res = await axios({
    method: 'delete',
    url: `${STUDY_API}/${id}`,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return res;
};

export const exportStudy = async ({
  accessToken,
  id,
}: {
  accessToken: string;
  id: string;
}) => {
  const STUDY_API = await getStudyApi();

  if (isEmpty(id)) return;
  const res: AxiosResponse = await axios({
    method: 'get',
    url: `${STUDY_API}/export/${id}`,
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${accessToken}`,
    },
    timeout: 300000,
    responseType: 'blob',
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return res;
};
